<template>
  <v-tooltip bottom v-if="flag">
    <template v-slot:activator="{ on, attrs }">
      <div class="country-flag-indicator" v-bind="attrs" v-on="on">
        {{ flag }}
      </div>
    </template>
    <span>Lieferung nach {{ name }}</span>
  </v-tooltip>
</template>

<script>
import { countryFlagEmoji, countryNameDe } from "@/utils";

// Lieferland der Bestellung als Flagge — Tooltip zeigt den Ländernamen.
// Rendert nichts, wenn kein shippingCountryCode am Task hängt (Alt-Tasks,
// die vor Einführung des Felds importiert wurden).
export default {
  name: "CountryFlagIndicator",
  props: {
    countryCode: {
      type: String,
      default: "",
    },
  },
  computed: {
    flag() {
      return countryFlagEmoji(this.countryCode);
    },
    name() {
      return countryNameDe(this.countryCode);
    },
  },
};
</script>

<style lang="scss" scoped>
.country-flag-indicator {
  height: 36px;
  min-width: 36px;
  border-radius: 18px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 12px 4px;
  padding: 0 6px;
  font-size: 22px;
  line-height: 1;
  user-select: none;
  cursor: default;
  background-color: rgba(255, 255, 255, 0.18);
}
</style>
